import React, { Fragment, useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Input from '../utils/Input';
import { fetchSource, fetchFilials, deleteCommission, createCommission, updateCommission } from '../../action/handbook';
import Select from 'react-select';
import Loader from '../utils/Loader';
import cn from 'classnames';
import ErrorContainer from '../utils/ErrorContainer';
import { withRouter } from 'react-router-dom';
import { setUIvisible } from '../../action/UImobile';
import { isEmpty } from 'lodash';
import PointsSelect from '../utils/PointsSelect';

const styles = {
  loading: {
    minHeight: '500px',
    display: 'flex',
    justifyContent: 'center'
  }
};

const optionsType = [
  { label: 'Проценты', value: 'persent' },
  { label: 'Сумма', value: 'sum' },
  { label: 'Сумма + Проценты', value: 'combined' },
];

function ItemContent({ item, isNew, points, loading, onChange, onSave, onDelete }) {

  const renderPointLabel = (point) => {
    if (!point) return '';
    const cityName = point && (point.city && point.city.name) ? point.city.name : null 
    return `${cityName + ', '}${point.street || 'Улица не указана'} ${point.house || ''}`
  }

  const selectedPoints = useMemo(() => {
    if (item.allPoints) {
      return points.map((point) => ({ label: renderPointLabel(point), value: point.id }));
    } else {
      return points.filter((point) => (item.pointsIds || []).includes(point.id)).map((point) => ({ label: renderPointLabel(point), value: point.id }));
    }

  }, [item.allPoints, item.pointsIds, points]);

  const handlePointsChange = (selectedOptions) => {
    const selectedIds = selectedOptions.map((opt) => +opt.value);
    const allSelected = selectedIds.length === points.length && points.length > 0;
    const id = isNew ? 'new' : item.id;
    onChange(id, 'points', { all: allSelected, ids: selectedIds });
  };

  const isValid = () => {
    if (!item.allPoints && isEmpty(item.pointsIds)) return false;
    if (!item.type) return false;

    if (item.type === 'sum' || item.type === 'combined') {
      if (!item.sum && !item.sumAgg) return false;
    }

    if (item.type === 'persent' || item.type === 'combined') {
      if (!item.persent && !item.persentAgg) return false;
    }

    if (!isNew && !item.isChange) return false;
    return true;
  };

  const handleFieldChange = (field, value) => {
    const id = isNew ? 'new' : item.id;
    onChange(id, field, value);
  };

  const handleSave = async () => {
    await onSave(item, isNew);
  };

  const handleDelete = async () => {
    if (!isNew && item.id) await onDelete(item.id);
  };

  return (
    <div className="kt-portlet">
      <div className="kt-portlet__head">
        <div className="kt-portlet__head-label">
          <h3 className="kt-portlet__head-title">
            {isNew ? 'Новая комиссия' : `Комиссия id: ${item.id}`}
          </h3>
        </div>
      </div>
      <div className="kt-portlet__body">
        <div className="row">
          <div className="col-md-3">
            <div className="form-group row">
              <label className="col-12 col-form-label">Филиалы *</label>
              <div className="col-12">
                <PointsSelect
                  width={326}
                  placeholder="Филиалы"
                  values={selectedPoints}
                  options={points}
                  setData={handlePointsChange}
                />
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group row">
              <label className="col-12 col-form-label">Тип комиссии *</label>
              <div className="col-12">
                <Select
                  value={item.type ? optionsType.find((option) => option.value === item.type) : null}
                  closeMenuOnSelect={true}
                  options={optionsType}
                  onChange={(e) => handleFieldChange('type', e.value)}
                  placeholder="Тип"
                  noOptionsMessage={() => 'Типы не найдены'}
                />
              </div>
            </div>
          </div>
        </div>

        <div className='row'>
          <div className='col-12'>
            <h5 className='kt-portlet__head-title' style={{ color: '#000' }}> Доставка нашими курьерами </h5>
          </div>
        </div>

        <div className="row">
          {(item.type === 'sum' || item.type === 'combined') && (
            <div className="col-md-3">
              <div className="form-group row">
                <div className="col-12">
                  <Input
                    label="Сумма"
                    required={true}
                    onChange={(e) => {
                      let value = e.target.value;
                    
                      value = value.replace(/[^0-9.,]/g, '');
                      value = value.replace(',', '.');
                    
                      const parts = value.split('.');
                      if (parts.length > 2) value = parts[0] + '.' + parts.slice(1).join('');
                    
                      const num = parseFloat(value);
                    
                      if (!isNaN(num)) {
                        handleFieldChange('sum', num);
                      } else {
                        handleFieldChange('sum', '');
                      }
                    }}
                    value={item.sum}
                    isControlledInput={true}
                    placeholder="Введите сумму"
                    type="number"
                  />
                </div>
              </div>
            </div>
          )}

          {(item.type === 'persent' || item.type === 'combined') && (
            <div className="col-md-3">
              <div className="form-group row">
                <div className="col-12">
                  <Input
                    label="Проценты"
                    required={true}
                    onChange={(e) => {
                      let value = e.target.value;
                    
                      value = value.replace(/[^0-9.,]/g, '');
                      value = value.replace(',', '.');
                    
                      const parts = value.split('.');
                      if (parts.length > 2) value = parts[0] + '.' + parts.slice(1).join('');
                    
                      const num = parseFloat(value);
                    
                      if (!isNaN(num)) {
                        const clamped = Math.min(num, 100);
                        handleFieldChange('persent', clamped);
                      } else {
                        handleFieldChange('persent', '');
                      }
                    }}
                    value={item.persent}
                    isControlledInput={true}
                    placeholder="Введите проценты"
                    type="number"
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="kt-separator kt-separator--border-2x kt-separator--space-sm"></div>

        <div className='row'>
          <div className='col-12'>
            <h5 className='kt-portlet__head-title' style={{ color: '#000' }}> Доставка курьерами сервиса </h5>
          </div>
        </div>

        <div className="row">
          {(item.type === 'sum' || item.type === 'combined') && (
            <div className="col-md-3">
              <div className="form-group row">
                <div className="col-12">
                  <Input
                    label="Сумма"
                    required={true}
                    onChange={(e) => {
                      let value = e.target.value;
                    
                      value = value.replace(/[^0-9.,]/g, '');
                      value = value.replace(',', '.');
                    
                      const parts = value.split('.');
                      if (parts.length > 2) value = parts[0] + '.' + parts.slice(1).join('');
                    
                      const num = parseFloat(value);
                    
                      if (!isNaN(num)) {
                        handleFieldChange('sumAgg', num);
                      } else {
                        handleFieldChange('sumAgg', '');
                      }
                    }}
                    value={item.sumAgg}
                    isControlledInput={true}
                    placeholder="Введите сумму"
                    type="number"
                  />
                </div>
              </div>
            </div>
          )}

          {(item.type === 'persent' || item.type === 'combined') && (
            <div className="col-md-3">
              <div className="form-group row">
                <div className="col-12">
                  <Input
                    label="Проценты"
                    required={true}
                    onChange={(e) => {
                      let value = e.target.value;
                    
                      value = value.replace(/[^0-9.,]/g, '');
                      value = value.replace(',', '.');
                    
                      const parts = value.split('.');
                      if (parts.length > 2) value = parts[0] + '.' + parts.slice(1).join('');
                    
                      const num = parseFloat(value);
                    
                      if (!isNaN(num)) {
                        const clamped = Math.min(num, 100);
                        handleFieldChange('persentAgg', clamped);
                      } else {
                        handleFieldChange('persentAgg', '');
                      }
                    }}
                    value={item.persentAgg}
                    isControlledInput={true}
                    placeholder="Введите проценты"
                    type="number"
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="kt-portlet__foot">
          <div className="kt-form__actions" style={{ display: 'flex', gap: 10 }}>
            {!isNew && (
              <button
                disabled={loading}
                className="btn btn-brand"
                onClick={handleDelete}
              >
                Удалить
              </button>
            )}
            <button
              disabled={!isValid() || loading}
              className={cn({
                'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true,
                'kt-spinner': loading,
              })}
              onClick={handleSave}
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function EditSourceCommissions({ history, match }) {
  const loading = useSelector((state) => state.loaders.sources);
  const points = useSelector((state) => state.handbook.filials);
  const pointsCount = useSelector((state) => state.handbook.count.filials);
  const pointLoading = useSelector((state) => state.loaders.filials);
  const commissionLoading = useSelector((state) => state.loaders.commission);

  const loader = loading || pointLoading;
  const dispatch = useDispatch();

  const [commissions, setCommissions] = useState([]);
  const [newCommission, setNewCommission] = useState({
    type: 'persent',
    sum: 0,
    persent: 0,
    sumAgg: 0,
    persentAgg: 0,
    pointsIds: [],
    allPoints: false,
    sources: [ match.params.id ],
  });
  const [source, setSource] = useState({});
  const [saving, setSaving] = useState(false);

  const getData = async () => {
    const sourceData = await dispatch(fetchSource(match.params.id));

    if (!isEmpty(sourceData)) {
      setSource(sourceData);
      const comms = (sourceData.commissions || []).map((c) => ({
        ...c,
        allPoints: c.allPoints || false,
        isChange: false,
      }));
      setCommissions(comms);
    }

    if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) {
      await dispatch(fetchFilials(null, true));
    }
  };

  useEffect(() => {
    dispatch(setUIvisible(false, false));
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const getAvailablePoints = (commissionId) => {
    const occupiedIds = new Set();
    let hasAll = false;

    for (const comm of commissions) {
      if (commissionId !== null && comm.id === commissionId) continue;

      if (comm.allPoints) {
        hasAll = true;
        break;
      }

      if (comm.pointsIds) comm.pointsIds.forEach((id) => occupiedIds.add(id));
    }

    if (hasAll) return [];
    return points.filter((p) => !occupiedIds.has(p.id));
  };

  const handleCommissionChange = (id, field, value) => {
    if (field === 'points') {
      const { all, ids } = value;
      if (id === 'new') {
        setNewCommission((prev) => ({
          ...prev,
          allPoints: all,
          pointsIds: all ? [] : ids,
          isChange: true,
        }));
      } else {
        setCommissions((prev) =>
          prev.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                allPoints: all,
                pointsIds: all ? [] : ids,
                isChange: true,
              };
            }
            return item;
          })
        );
      }
    } else {
      if (id === 'new') {
        setNewCommission((prev) => {
          const updated = { ...prev, [field]: value, isChange: true };
          if (field === 'type') {
            updated.sum = 0;
            updated.persent = 0;
            updated.sumAgg = 0;
            updated.persentAgg = 0;
          }
          return updated;
        });
      } else {
        setCommissions((prev) =>
          prev.map((item) => {
            if (item.id === id) {
              const updated = { ...item, [field]: value, isChange: true };
              if (field === 'type') {
                updated.sum = 0;
                updated.persent = 0;
                updated.sumAgg = 0;
                updated.persentAgg = 0;
              }
              return updated;
            }
            return item;
          })
        );
      }
    }
  };

  const handleSave = async (item, isNew) => {
    setSaving(true);
    try {
      let result;
      if (isNew) {
        result = await dispatch(createCommission(item));
        if (result) {
          await getData();
          setNewCommission({
            type: 'persent',
            sum: 0,
            persent: 0,
            pointsIds: [],
            allPoints: false,
            sources: [ match.params.id ],
          });
        }
      } else {
        result = await dispatch(updateCommission(item, item.id));
        if (result) await getData();
      }
    } catch (error) {
      console.error('Save error', error);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    setSaving(true);
    try {
      const result = await dispatch(deleteCommission(id));
      if (result) await getData();
    } catch (error) {
      console.error('Delete error', error);
    } finally {
      setSaving(false);
    }
  };

  const renderSubHeader = () => (
    <div className="kt-subheader not-mt kt-grid__item">
      <div className="kt-container  kt-container--fluid">
        <div className="kt-subheader__main">
          <h3 className="kt-subheader__title">
            Комиссии источника {source ? source.name || source.value : ''}
          </h3>
          <span className="kt-subheader__separator kt-subheader__separator--v"></span>
        </div>
        <div className="kt-subheader__toolbar">
          <button onClick={() => history.push('/handbook/sources')} className="btn btn-default btn-bold">
            Назад
          </button>
        </div>
      </div>
    </div>
  );

  if (loader) {
    return (
      <div style={styles.loading}>
        <Loader />
      </div>
    );
  }

  const isSaving = saving || commissionLoading;

  return (
    <Fragment>
      {renderSubHeader()}
      <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        {commissions.map((commission) => {
          const availablePoints = getAvailablePoints(commission.id);
          return (
            <ItemContent
              key={commission.id}
              item={commission}
              isNew={false}
              points={availablePoints}
              loading={isSaving}
              onChange={handleCommissionChange}
              onSave={handleSave}
              onDelete={handleDelete}
            />
          );
        })}

        {getAvailablePoints(null).length > 0 && (
          <ItemContent
            key="new"
            item={newCommission}
            isNew={true}
            points={getAvailablePoints(null)}
            loading={isSaving}
            onChange={handleCommissionChange}
            onSave={handleSave}
            onDelete={handleDelete}
          />
        )}

        <ErrorContainer field="commission" style={{ margin: '0 20px 20px' }} hasCloseButton={true} />
      </div>
    </Fragment>
  );
}

export default withRouter(EditSourceCommissions);